<template>
  <div class="w-full h-full flex items-center justify-center">
    <div class="page-404 flex flex-col h-screen items-center justify-center">
      <h1 class="text-grey text-404">404</h1>
      <img src="../../assets/images/404.png" />
      <h2 class="my-8 text-grey-dark">Oops! Page not found</h2>
      <div>Please try with a proper address or get back to our home page</div>
      <router-link
        :to="{ name: 'login' }"
        class="my-4 h-8 bg-white p-2 rounded no-underline text-black font-bold"
      >
        Back to Home
      </router-link>
      <a
        class="cursor-pointer p-2 bg-grey rounded"
        @click="handleLogout"
      > Logout</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  mounted() {
    if (window.zE) {
      window.zE('webWidget', 'hide');
    }
  },
  methods: {
    handleLogout() {
      this.$sendEvent('RS_Logout');
      this.logOut().then(() => {
        this.$router.push({ name: 'login' });
      });
    },
    ...mapActions({
      logOut: 'auth/logOut',
    }),
  },
};
</script>
